import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { Category } from '@us/web/shared/data-access';
import { ProductsComponent } from '../products/products.component';

@Component({
    selector: 'us-categories-page',
    standalone: true,
    imports: [CommonModule, IonicModule, TranslocoModule, ProductsComponent],
    templateUrl: './categories.page.html',
    styleUrls: ['./categories.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoriesPage {
    currentCategory: Category | null = null;
}
